import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { Whatsapp } from 'react-bootstrap-icons';
import './WhatsAppInput.scss';

interface WhatsAppInputProps {
  onSend: (phone: string, countryCode: string) => void;
  onCancel: () => void;
}

interface Country {
  code: string;
  name: string;
  flag: string;
  prefix: string;
  placeholder: string;
  minLength: number;
  maxLength: number;
}

const WhatsAppInput: React.FC<WhatsAppInputProps> = ({ onSend, onCancel }) => {
  const [phone, setPhone] = useState<string>('');
  const [selectedCountry, setSelectedCountry] = useState<string>('CL');

  const countries: Country[] = [
    { 
      code: 'CL', 
      name: 'Chile', 
      flag: '🇨🇱', 
      prefix: '+56 9', 
      placeholder: '12345678',
      minLength: 8,
      maxLength: 8 
    },
    { 
      code: 'AR', 
      name: 'Argentina', 
      flag: '🇦🇷', 
      prefix: '+54 9', 
      placeholder: '11 1234 5678',
      minLength: 10,
      maxLength: 10 
    },
    { 
      code: 'CO', 
      name: 'Colombia', 
      flag: '🇨🇴', 
      prefix: '+57', 
      placeholder: '300 123 4567',
      minLength: 10,
      maxLength: 10 
    },
    { 
      code: 'PE', 
      name: 'Perú', 
      flag: '🇵🇪', 
      prefix: '+51', 
      placeholder: '987 654 321',
      minLength: 9,
      maxLength: 9 
    }
  ];

  const selectedCountryData = countries.find(c => c.code === selectedCountry) || countries[0];

  const handleSend = () => {
    if (phone.trim()) {
      onSend(phone, selectedCountry);
    }
  };

  const isValidPhone = () => {
    const cleanPhone = phone.replace(/\s/g, '');
    return cleanPhone.length >= selectedCountryData.minLength && 
           cleanPhone.length <= selectedCountryData.maxLength;
  };

  return (
    <div className="whatsapp-input-section">
      <h6 className="input-title">Ingresa el número de WhatsApp</h6>
      
      <div className="phone-input-container">
        <Form.Select
          className="country-selector"
          value={selectedCountry}
          onChange={(e) => setSelectedCountry(e.target.value)}
        >
          {countries.map((country) => (
            <option key={country.code} value={country.code}>
              {country.flag} {country.name} ({country.prefix})
            </option>
          ))}
        </Form.Select>

        <div className="phone-input-wrapper">
          <span className="country-prefix">{selectedCountryData.prefix}</span>
          <Form.Control
            type="tel"
            className="phone-input"
            placeholder={selectedCountryData.placeholder}
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && isValidPhone() && handleSend()}
          />
        </div>

        {phone && !isValidPhone() && (
          <div className="validation-message">
            Número inválido para {selectedCountryData.name}
          </div>
        )}
      </div>

      <div className="action-buttons">
        <Button 
          className="cancel-btn" 
          variant="outline-secondary"
          onClick={onCancel}
        >
          Cancelar
        </Button>
        <Button 
          className="send-btn" 
          onClick={handleSend}
          disabled={!isValidPhone()}
        >
          <Whatsapp size={18} />
          Enviar
        </Button>
      </div>
    </div>
  );
};

export default WhatsAppInput;
